module.exports = __webpack_public_path__ + "res/img_info_t.df0ad70161b2e2c45f3dd4bde1be5e99.png";